import React from 'react';
import ReactDOM from 'react-dom';
import ToolBar from './MenuSide';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<ToolBar />, document.getElementById('root'), function () {
//    console.log("render done.");
//    SetDefaultObj();    // 使用 callback 無效。似乎還是在整個圖台結構建立完之前
    setTimeout(SetDefaultObj, 3000);    // 假設 3秒後整個圖台結構立完成
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// ==============================================

function getURLParameter(name)
{
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}
function SetDefaultObj()
{
    let id = getURLParameter("id");

    console.log("Load default object: " + id);

    if(id != null)
    {
        document.getElementById(id).click();
    }
}

